import { i18n } from "./i18n";

const languageCode = () =>
  String(i18n.language || localStorage.getItem("i18nextLng") || "pt")
    .split("-")[0]
    .toLowerCase();

export const getLocale = () => {
  const locales = {
    pt: "pt-BR",
    en: "en-US",
    es: "es-ES"
  };

  return locales[languageCode()] || locales.pt;
};

export const interpolate = (template, values = {}) =>
  String(template || "").replace(/\{\{(\w+)\}\}/g, (_, key) =>
    values[key] === undefined || values[key] === null ? "" : String(values[key])
  );

const dashboardTexts = {
  pt: {
    title: "Panel gerencial",
    base: "Base",
    quickActions: "Ações rapidas",
    refresh: "Atualizar",
    exportExcel: "Exportar Excel",
    all: "Todas",
    allMale: "Todos",
    distributionEmpty: "Sem distribuicao",
    periods: {
      today: "Hoje",
      week: "Esta Semana",
      month: "Este Mes",
      quarter: "Últimos 3 Meses",
      year: "Este Ano",
      custom: "Personalizado"
    },
    periodRange: {
      from: "Inicio",
      to: "Fim",
      locale: "pt-BR",
      covering: "Periodo: {{from}} a {{to}}",
      single: "Periodo: {{date}}"
    },
    queuePressure: {
      title: "Fila mais pressionada",
      subtitle: "Backlog AGORA (em atendimento + aguardando), independente do periodo selecionado.",
      backlogDetail: "{{backlog}} ({{open}} em atendimento, {{pending}} aguardando)",
      empty: "Nenhum atendimento em aberto no momento.",
      tagsTitle: "Diagnostico por etiquetas",
      tagsSubtitle: "{{tagged}} de {{total}} atendimentos com etiqueta; {{untagged}} sem etiqueta. Um atendimento pode ter mais de uma, entao a soma nao fecha com o total.",
      tagsEmpty: "Nenhuma etiqueta registrada no periodo."
    },
    reasonCategories: {
      title: "Motivos por categoria",
      subtitle: "Categoria extraida do proprio assunto {{period}} (prefixo antes do travessao).",
      empty: "Nenhum atendimento com assunto no periodo."
    },
    reasons: {
      title: "Motivos de chamado por fila",
      subtitle: "Assunto dos atendimentos {{period}}, agrupado pela fila.",
      empty: "Nenhum atendimento com assunto no periodo."
    },
    recognition: {
      title: "Reconhecimento por operador",
      subtitle: "Atendimentos {{period}}, fila predominante e principais motivos.",
      bestCsat: "Melhor CSAT: {{name}} — score {{score}} (media {{average}} em {{count}} avaliacoes, ajustada pelo volume).",
      agentValue: "{{total}} atendimentos · CSAT {{csat}}",
      noRating: "sem avaliacao",
      noReasons: "sem assunto registrado",
      empty: "Nenhum atendimento atribuido no periodo."
    },
    businessHours: {
      title: "Painel gerencial",
      subtitle: "Distribuicao dos {{total}} atendimentos {{period}}, pela {{basis}}. As faixas nao se sobrepoem.",
      inHours: "Dentro do expediente",
      afterHours: "Fora do expediente (seg a sex)",
      saturday: "Sabado",
      sunday: "Domingo",
      byStateTitle: "Backlog de agora, pela data de abertura:",
      stateOpen: "Em atendimento",
      statePending: "Aguardando",
      stateDetail: "{{inHours}} expediente · {{afterHours}} fora · {{saturday}} sab · {{sunday}} dom",
      share: "{{share}} do periodo"
    },
    periodDescriptors: {
      today: "hoje",
      week: "nesta semana",
      month: "neste mes",
      quarter: "nos últimos 3 meses",
      year: "neste ano",
      custom: "no periodo selecionado"
    },
    dateBasis: {
      closedAt: "Data de fechamento",
      createdAt: "Data de abertura"
    },
    export: {
      period: "Per\u00edodo",
      dateBasis: "Base temporal",
      chartQueue: "Fila do grafico",
      currentView: "Visao atual da operacao",
      byAttendant: "Atendimentos por atendente no per\u00edodo",
      byQueue: "Atendimentos por fila no per\u00edodo",
      byConnection: "Atendimentos por conex\u00e3o no per\u00edodo",
      byHandledMode: "Atendimentos por modo de atendimento",
      topClients: "Top clientes no per\u00edodo",
      attendantRhythm: "Ritmo por atendente",
      ticketsInPeriod: "Atendimentos no per\u00edodo",
      attendant: "Atendente",
      queue: "Fila",
      connection: "Conex\u00e3o",
      handledMode: "Modo de atendimento",
      client: "Cliente",
      number: "Número",
      volume: "Atendimentos",
      metrics: {
        open: "Em atendimento",
        pending: "Aguardando",
        unread: "Não lidos",
        closedToday: "Encerrados hoje",
        tme: "TME (min)",
        tma: "TMA (min)",
        users: "Usu\u00e1rios",
        queues: "Filas",
        connections: "Conex\u00f5es",
        contacts: "Contatos"
      }
    },
    kpis: {
      open: {
        title: "Em atendimento",
        subtitle: "Visao atual dos tickets em execução."
      },
      pending: {
        title: "Aguardando",
        subtitle: "Fila atual de tickets aguardando ação."
      },
      unread: {
        title: "Não lidos",
        subtitle: "Conversas com mensagens pendentes agora."
      },
      closedToday: {
        title: "Encerrados hoje",
        subtitle: "Fechamentos registrados no dia atual."
      },
      closedPeriod: {
        title: "Encerrados no per\u00edodo",
        subtitle: "Fechamentos registrados no per\u00edodo selecionado."
      },
      internalOpen: {
        title: "Abertos",
        userSubtitle: "Tickets internos ativos atribuidos a você.",
        adminSubtitle: "Tickets internos ativos da operacao."
      },
      dueSoon: {
        title: "A vencer",
        subtitle: "Itens internos que vencem nas proximas 24 horas."
      },
      overdue: {
        title: "Vencidos",
        subtitle: "Itens internos fora do prazo neste momento."
      }
    },
    highlights: {
      topUser: {
        title: "Atendente em destaque",
        subtitle: "{{count}} atendimentos concentrados no per\u00edodo.",
        empty: "Assim que houver movimentação, o ranking aparece aqui."
      },
      topQueue: {
        title: "Fila com mais atendimentos",
        subtitle: "{{count}} atendimentos concentrados nesta fila no periodo.",
        empty: "Nenhuma fila com volume suficiente neste recorte."
      },
      topConnection: {
        title: "Conex\u00e3o mais usada",
        subtitle: "{{count}} atendimentos usando esta conex\u00e3o.",
        empty: "Nenhuma conex\u00e3o em destaque no per\u00edodo."
      }
    },
    panels: {
      volumeTooltip: "Volume",
      attendanceSuffix: "atendimentos",
      pieEmpty: "Ainda não ha volume suficiente no per\u00edodo para preencher este grafico.",
      timelineTitle: "Ritmo da operacao",
      timelineSubtitle: "Evolucao dos atendimentos por atendente em {{period}}.",
      timelineEmpty: "Ainda não ha atendimentos suficientes nesse recorte para desenhar a linha por atendente.",
      performanceTitle: "TME e TMA",
      performanceSubtitle: "Evolucao do tempo medio de primeira resposta e do tempo medio de atendimento em {{period}}.",
      attendant: "Atendente",
      queue: "Fila",
      averageTme: "TME medio",
      averageTma: "TMA medio",
      firstResponse: "Tickets com 1a resposta",
      completeTma: "Tickets com TMA completo",
      performanceEmpty: "Ainda não ha tickets suficientes nesse recorte para calcular TME e TMA.",
      topClientsTitle: "Top 10 clientes",
      topClientsSubtitle: "Clientes com maior volume de atendimentos em {{period}}.",
      noNumber: "Sem número",
      topClientsEmpty: "Ainda não ha clientes suficientes no per\u00edodo para montar este ranking.",
      byAttendantTitle: "Atendimentos por atendente",
      byAttendantSubtitle: "Distribuicao dos atendimentos em {{period}}.",
      byQueueTitle: "Atendimentos por fila",
      byQueueSubtitle: "Onde a demanda ficou concentrada em {{period}}.",
      byConnectionTitle: "Atendimentos por conex\u00e3o",
      byConnectionSubtitle: "Carga operacional por conex\u00e3o em {{period}}.",
      byHandledModeTitle: "Modo de atendimento",
      byHandledModeSubtitle: "Distribuicao entre humano, IA, hibrido e integração em {{period}}.",
      operationalBaseTitle: "Base operativa",
      operationalBaseSubtitle: "Visao resumida da estrutura e do mix atual de atendimento.",
      activeUsers: "Usu\u00e1rios ativos",
      configuredQueues: "Filas configuradas",
      whatsappConnections: "Conex\u00f5es WhatsApp",
      registeredContacts: "Contatos cadastrados",
      privateGroups: "Privados / grupos",
      ratingsTitle: "Avaliações dos atendimentos",
      ratingsSubtitle: "Notas recebidas dos clientes em {{period}}.",
      ratingsAverage: "Nota media",
      ratingsAnswered: "Respondidas",
      ratingsPending: "Aguardando resposta",
      ratingsDistribution: "Distribuicao das notas",
      ratingsLatest: "Ultimas avaliações",
      ratingsNoData: "Ainda não ha avaliações respondidas neste per\u00edodo.",
      ratingsNoComment: "Sem coment\u00e1rio",
      ratingsMode: {
        human: "Humano",
        ai: "IA",
        hybrid: "Hibrido",
        api: "Integração/API",
        unknown: "Não identificado"
      }
    }
  },
  en: {
    title: "Management dashboard",
    base: "Basis",
    quickActions: "Quick actions",
    refresh: "Refresh",
    exportExcel: "Export Excel",
    all: "All",
    allMale: "All",
    distributionEmpty: "No distribution",
    periods: { today: "Today", week: "This Week", month: "This Month", quarter: "Last 3 Months", year: "This Year", custom: "Custom" },
    periodRange: {
      from: "Start",
      to: "End",
      locale: "en-US",
      covering: "Period: {{from}} to {{to}}",
      single: "Period: {{date}}"
    },
    queuePressure: {
      title: "Most pressured queue",
      subtitle: "Backlog RIGHT NOW (in service + waiting), regardless of the selected period.",
      backlogDetail: "{{backlog}} ({{open}} in service, {{pending}} waiting)",
      empty: "No open attendances at the moment.",
      tagsTitle: "Tag diagnosis",
      tagsSubtitle: "{{tagged}} of {{total}} attendances tagged; {{untagged}} untagged. One attendance may carry several tags, so the sum does not match the total.",
      tagsEmpty: "No tags recorded in the period."
    },
    reasonCategories: {
      title: "Reasons by category",
      subtitle: "Category taken from the subject itself {{period}} (prefix before the dash).",
      empty: "No attendance with a subject in the period."
    },
    reasons: {
      title: "Contact reasons by queue",
      subtitle: "Attendance subjects {{period}}, grouped by queue.",
      empty: "No attendance with a subject in the period."
    },
    recognition: {
      title: "Recognition by operator",
      subtitle: "Attendances {{period}}, main queue and top reasons.",
      bestCsat: "Best CSAT: {{name}} — score {{score}} (average {{average}} across {{count}} ratings, volume-adjusted).",
      agentValue: "{{total}} attendances · CSAT {{csat}}",
      noRating: "no rating",
      noReasons: "no subject recorded",
      empty: "No attendance assigned in the period."
    },
    businessHours: {
      title: "Management panel",
      subtitle: "Breakdown of {{total}} attendances {{period}}, by {{basis}}. Buckets do not overlap.",
      inHours: "Within business hours",
      afterHours: "After hours (Mon-Fri)",
      saturday: "Saturday",
      sunday: "Sunday",
      byStateTitle: "Current backlog, by opening date:",
      stateOpen: "In service",
      statePending: "Waiting",
      stateDetail: "{{inHours}} in hours · {{afterHours}} after · {{saturday}} sat · {{sunday}} sun",
      share: "{{share}} of the period"
    },
    periodDescriptors: { today: "today", week: "this week", month: "this month", quarter: "in the last 3 months", year: "this year", custom: "in the selected period" },
    dateBasis: { closedAt: "Closing date", createdAt: "Opening date" },
    export: {
      period: "Period",
      dateBasis: "Time basis",
      chartQueue: "Chart queue",
      currentView: "Current operation view",
      byAttendant: "Tickets by attendant in period",
      byQueue: "Tickets by queue in period",
      byConnection: "Tickets by connection in period",
      byHandledMode: "Tickets by handling mode in period",
      topClients: "Top clients in period",
      attendantRhythm: "Attendant rhythm",
      ticketsInPeriod: "Tickets in period",
      attendant: "Attendant",
      queue: "Queue",
      connection: "Connection",
      handledMode: "Handling mode",
      client: "Client",
      number: "Number",
      volume: "Tickets",
      metrics: {
        open: "In service",
        pending: "Waiting",
        unread: "Unread",
        closedToday: "Closed today",
        tme: "FRT (min)",
        tma: "AHT (min)",
        users: "Users",
        queues: "Queues",
        connections: "Connections",
        contacts: "Contacts"
      }
    },
    kpis: {
      open: { title: "In service", subtitle: "Current view of active tickets." },
      pending: { title: "Waiting", subtitle: "Tickets currently waiting for action." },
      unread: { title: "Unread", subtitle: "Conversations with pending messages now." },
      closedToday: { title: "Closed today", subtitle: "Closings registered today." },
      closedPeriod: { title: "Closed in period", subtitle: "Closings registered in the selected period." },
      internalOpen: { title: "Open", userSubtitle: "Active internal tickets assigned to you.", adminSubtitle: "Active internal tickets in the operation." },
      dueSoon: { title: "Due soon", subtitle: "Internal items due in the next 24 hours." },
      overdue: { title: "Overdue", subtitle: "Internal items currently past due." }
    },
    highlights: {
      topUser: { title: "Top attendant", subtitle: "{{count}} tickets concentrated in the period.", empty: "Once activity starts, the ranking appears here." },
      topQueue: { title: "Queue with most attendances", subtitle: "{{count}} tickets concentrated in this queue in the period.", empty: "No queue has enough volume in this slice." },
      topConnection: { title: "Most used connection", subtitle: "{{count}} tickets using this connection.", empty: "No highlighted connection in the period." }
    },
    panels: {
      volumeTooltip: "Volume",
      attendanceSuffix: "tickets",
      pieEmpty: "There is not enough volume in this period to fill this chart yet.",
      timelineTitle: "Operation rhythm",
      timelineSubtitle: "Ticket evolution by attendant {{period}}.",
      timelineEmpty: "There are not enough tickets in this slice to draw the attendant line yet.",
      performanceTitle: "FRT and AHT",
      performanceSubtitle: "Average first response time and average handling time evolution {{period}}.",
      attendant: "Attendant",
      queue: "Queue",
      averageTme: "Average FRT",
      averageTma: "Average AHT",
      firstResponse: "Tickets with 1st response",
      completeTma: "Tickets with complete AHT",
      performanceEmpty: "There are not enough tickets in this slice to calculate FRT and AHT yet.",
      topClientsTitle: "Top 10 clients",
      topClientsSubtitle: "Clients with the highest ticket volume {{period}}.",
      noNumber: "No number",
      topClientsEmpty: "There are not enough clients in this period to build this ranking yet.",
      byAttendantTitle: "Tickets by attendant",
      byAttendantSubtitle: "Ticket distribution {{period}}.",
      byQueueTitle: "Tickets by queue",
      byQueueSubtitle: "Where demand was concentrated {{period}}.",
      byConnectionTitle: "Tickets by connection",
      byConnectionSubtitle: "Operational load by connection {{period}}.",
      byHandledModeTitle: "Service mode",
      byHandledModeSubtitle: "Distribution between human, AI, hybrid and integration service {{period}}.",
      operationalBaseTitle: "Operational base",
      operationalBaseSubtitle: "Summary view of the current service structure and mix.",
      activeUsers: "Active users",
      configuredQueues: "Configured queues",
      whatsappConnections: "WhatsApp connections",
      registeredContacts: "Registered contacts",
      privateGroups: "Private / groups",
      ratingsTitle: "Service ratings",
      ratingsSubtitle: "Customer scores received {{period}}.",
      ratingsAverage: "Average score",
      ratingsAnswered: "Answered",
      ratingsPending: "Waiting response",
      ratingsDistribution: "Score distribution",
      ratingsLatest: "Latest ratings",
      ratingsNoData: "There are no answered ratings in this period yet.",
      ratingsNoComment: "No comment",
      ratingsMode: {
        human: "Human",
        ai: "AI",
        hybrid: "Hybrid",
        api: "Integration/API",
        unknown: "Unidentified"
      }
    }
  },
  es: {
    title: "Dashboard gerencial",
    base: "Base",
    quickActions: "Acciones rapidas",
    refresh: "Actualizar",
    exportExcel: "Exportar Excel",
    all: "Todas",
    allMale: "Todos",
    distributionEmpty: "Sin distribucion",
    periods: { today: "Hoy", week: "Esta Semana", month: "Este Mes", quarter: "Últimos 3 Meses", year: "Este Ano", custom: "Personalizado" },
    periodRange: {
      from: "Inicio",
      to: "Fin",
      locale: "es-ES",
      covering: "Periodo: {{from}} a {{to}}",
      single: "Periodo: {{date}}"
    },
    queuePressure: {
      title: "Cola mas presionada",
      subtitle: "Backlog AHORA (en atencion + esperando), sin importar el periodo seleccionado.",
      backlogDetail: "{{backlog}} ({{open}} en atencion, {{pending}} esperando)",
      empty: "Ninguna atencion abierta en este momento.",
      tagsTitle: "Diagnostico por etiquetas",
      tagsSubtitle: "{{tagged}} de {{total}} atenciones con etiqueta; {{untagged}} sin etiqueta. Una atencion puede tener varias, por eso la suma no coincide con el total.",
      tagsEmpty: "Ninguna etiqueta registrada en el periodo."
    },
    reasonCategories: {
      title: "Motivos por categoria",
      subtitle: "Categoria extraida del propio asunto {{period}} (prefijo antes del guion).",
      empty: "Ninguna atencion con asunto en el periodo."
    },
    reasons: {
      title: "Motivos de contacto por cola",
      subtitle: "Asunto de las atenciones {{period}}, agrupado por cola.",
      empty: "Ninguna atencion con asunto en el periodo."
    },
    recognition: {
      title: "Reconocimiento por operador",
      subtitle: "Atenciones {{period}}, cola predominante y principales motivos.",
      bestCsat: "Mejor CSAT: {{name}} — score {{score}} (promedio {{average}} en {{count}} evaluaciones, ajustado por volumen).",
      agentValue: "{{total}} atenciones · CSAT {{csat}}",
      noRating: "sin evaluacion",
      noReasons: "sin asunto registrado",
      empty: "Ninguna atencion asignada en el periodo."
    },
    businessHours: {
      title: "Panel gerencial",
      subtitle: "Distribucion de {{total}} atenciones {{period}}, por {{basis}}. Las franjas no se superponen.",
      inHours: "Dentro del horario",
      afterHours: "Fuera de horario (lun a vie)",
      saturday: "Sabado",
      sunday: "Domingo",
      byStateTitle: "Backlog actual, por fecha de apertura:",
      stateOpen: "En atencion",
      statePending: "Esperando",
      stateDetail: "{{inHours}} horario · {{afterHours}} fuera · {{saturday}} sab · {{sunday}} dom",
      share: "{{share}} del periodo"
    },
    periodDescriptors: { today: "hoy", week: "esta semana", month: "este mes", quarter: "en los últimos 3 meses", year: "este ano", custom: "en el periodo seleccionado" },
    dateBasis: { closedAt: "Fecha de cierre", createdAt: "Fecha de apertura" },
    export: {
      period: "Per\u00edodo",
      dateBasis: "Base temporal",
      chartQueue: "Cola del grafico",
      currentView: "Vista actual de la operacion",
      byAttendant: "Atenciones por agente en el per\u00edodo",
      byQueue: "Atenciones por cola en el per\u00edodo",
      byConnection: "Atenciones por conexion en el per\u00edodo",
      byHandledMode: "Atenciones por modo de atencion en el per\u00edodo",
      topClients: "Top clientes en el per\u00edodo",
      attendantRhythm: "Ritmo por agente",
      ticketsInPeriod: "Atenciones en el per\u00edodo",
      attendant: "Agente",
      queue: "Cola",
      connection: "Conexion",
      handledMode: "Modo de atencion",
      client: "Cliente",
      number: "Numero",
      volume: "Atenciones",
      metrics: {
        open: "En atencion",
        pending: "Esperando",
        unread: "No leidos",
        closedToday: "Cerrados hoy",
        tme: "TPR (min)",
        tma: "TMA (min)",
        users: "Usu\u00e1rios",
        queues: "Colas",
        connections: "Conexiones",
        contacts: "Contactos"
      }
    },
    kpis: {
      open: { title: "En atencion", subtitle: "Vista actual de tickets en ejecucion." },
      pending: { title: "Esperando", subtitle: "Cola actual de tickets esperando accion." },
      unread: { title: "No leidos", subtitle: "Conversaciones con mensajes pendientes ahora." },
      closedToday: { title: "Cerrados hoy", subtitle: "Cierres registrados en el dia actual." },
      closedPeriod: { title: "Cerrados en el per\u00edodo", subtitle: "Cierres registrados en el per\u00edodo seleccionado." },
      internalOpen: { title: "Abiertos", userSubtitle: "Tickets internos activos asignados a ti.", adminSubtitle: "Tickets internos activos de la operacion." },
      dueSoon: { title: "Por vencer", subtitle: "Items internos que vencen en las proximas 24 horas." },
      overdue: { title: "Vencidos", subtitle: "Items internos fuera de plazo en este momento." }
    },
    highlights: {
      topUser: { title: "Agente destacado", subtitle: "{{count}} atenciones concentradas en el per\u00edodo.", empty: "Cuando haya movimiento, el ranking aparecera aqui." },
      topQueue: { title: "Cola con mas atenciones", subtitle: "{{count}} atenciones concentradas en esta cola en el periodo.", empty: "Ninguna cola con volumen suficiente en este recorte." },
      topConnection: { title: "Conexion mas usada", subtitle: "{{count}} atenciones usando esta conexion.", empty: "Ninguna conexion destacada en el per\u00edodo." }
    },
    panels: {
      volumeTooltip: "Volumen",
      attendanceSuffix: "atenciones",
      pieEmpty: "Aun no hay volumen suficiente en el per\u00edodo para completar este grafico.",
      timelineTitle: "Ritmo de la operacion",
      timelineSubtitle: "Evolucion de atenciones por agente {{period}}.",
      timelineEmpty: "Aun no hay atenciones suficientes en este recorte para dibujar la linea por agente.",
      performanceTitle: "TPR y TMA",
      performanceSubtitle: "Evolucion del tiempo medio de primera respuesta y del tiempo medio de atencion {{period}}.",
      attendant: "Agente",
      queue: "Cola",
      averageTme: "TPR medio",
      averageTma: "TMA medio",
      firstResponse: "Tickets con 1a respuesta",
      completeTma: "Tickets con TMA completo",
      performanceEmpty: "Aun no hay tickets suficientes en este recorte para calcular TPR y TMA.",
      topClientsTitle: "Top 10 clientes",
      topClientsSubtitle: "Clientes con mayor volumen de atenciones {{period}}.",
      noNumber: "Sin numero",
      topClientsEmpty: "Aun no hay clientes suficientes en el per\u00edodo para montar este ranking.",
      byAttendantTitle: "Atenciones por agente",
      byAttendantSubtitle: "Distribucion de atenciones {{period}}.",
      byQueueTitle: "Atenciones por cola",
      byQueueSubtitle: "Donde la demanda se concentro {{period}}.",
      byConnectionTitle: "Atenciones por conexion",
      byConnectionSubtitle: "Carga operacional por conexion {{period}}.",
      byHandledModeTitle: "Modo de atencion",
      byHandledModeSubtitle: "Distribucion entre humano, IA, hibrido e integracion {{period}}.",
      operationalBaseTitle: "Base operacional",
      operationalBaseSubtitle: "Vista resumida de la estructura y del mix actual de atencion.",
      activeUsers: "Usu\u00e1rios activos",
      configuredQueues: "Colas configuradas",
      whatsappConnections: "Conexiones WhatsApp",
      registeredContacts: "Contactos registrados",
      privateGroups: "Privados / grupos",
      ratingsTitle: "Evaluaciones de atencion",
      ratingsSubtitle: "Notas recibidas de los clientes {{period}}.",
      ratingsAverage: "Nota media",
      ratingsAnswered: "Respondidas",
      ratingsPending: "Esperando respuesta",
      ratingsDistribution: "Distribucion de notas",
      ratingsLatest: "Ultimas evaluaciones",
      ratingsNoData: "Aun no hay evaluaciones respondidas en este per\u00edodo.",
      ratingsNoComment: "Sin coment\u00e1rio",
      ratingsMode: {
        human: "Humano",
        ai: "IA",
        hybrid: "Hibrido",
        api: "Integracion/API",
        unknown: "No identificado"
      }
    }
  }
};

const internalChatTexts = {
  pt: {
    title: "Chat interno",
    refresh: "Atualizar",
    newConversation: "Nova conversa",
    newDirectConversation: "Nova conversa individual",
    newInternalConversation: "Nova conversa interna",
    type: "Tipo",
    chooseUser: "Escolha o usu\u00e1rio",
    groupName: "Nome do grupo",
    createConversation: "Criar conversa",
    search: "Buscar conversa",
    deleteTitle: "Apagar conversa",
    deleteGroup: "Deseja apagar este grupo interno para todos os participantes? As mensagens serão perdidas e não há como desfazer.",
    deleteDirect: "Deseja apagar esta conversa individual? Ela some para os dois lados, com todas as mensagens, e não há como desfazer.",
    leaveConversation: "Sair da conversa",
    leaveTitle: "Sair da conversa",
    leaveGroup: "Deseja sair deste grupo? Ele sai da sua lista e você para de receber as mensagens. Nada é apagado, e um administrador pode readicionar você.",
    leaveDirect: "Deseja sair desta conversa? Ela sai da sua lista sem apagar nada, e volta se a pessoa escrever de novo.",
    manageGroup: "Gerenciar integrantes do grupo",
    participants: "Participantes",
    groupAutoInclude: "O grupo sempre inclui você automaticamente.",
    cancel: "Cancelar",
    saveParticipants: "Salvar integrantes",
    group: "Grupo",
    direct: "Individual",
    unread: "{{count}} nova{{suffix}}",
    emptyTitle: "Nenhuma conversa interna",
    emptyAdmin: "Crie uma conversa individual ou um grupo para sua equipe.",
    emptyUser: "Crie uma conversa individual para falar com sua equipe.",
    headerGroupCount: "{{count}} participante{{suffix}}",
    directHeader: "Conversa individual",
    manageParticipants: "Gerenciar integrantes",
    deleteConversation: "Apagar conversa",
    userFallback: "Usu\u00e1rio",
    imageAlt: "Imagem enviada",
    openFile: "Abrir arquivo",
    file: "Arquivo",
    noMessagesTitle: "Sem mensagens ainda",
    noMessagesSubtitle: "Comece a conversa com sua equipe por aqui.",
    composerPlaceholder: "Digite uma mensagem interna",
    selectTitle: "Selecione uma conversa interna",
    selectSubtitle: "O chat interno individual e em grupo fica separado dos tickets, para a equipe colaborar sem misturar com o cliente.",
    today: "Hoje",
    yesterday: "Ontem",
    groupNoMessages: "Grupo interno sem mensagens",
    directNoMessages: "Conversa interna sem mensagens",
    groupFallback: "Grupo interno",
    directFallback: "Conversa interna",
    noParticipant: "Sem participante definido",
    media: {
      imageReady: "Imagem pronta para envio",
      audioReady: "Audio pronto para envio",
      pdfReady: "PDF pronto para envio",
      fileReady: "Arquivo pronto para envio"
    },
    errors: {
      mediaType: "Apenas JPEG, PNG e PDF são permitidos no chat interno."
    }
  },
  en: {
    title: "Internal chat",
    refresh: "Refresh",
    newConversation: "New conversation",
    newDirectConversation: "New direct conversation",
    newInternalConversation: "New internal conversation",
    type: "Type",
    chooseUser: "Choose user",
    groupName: "Group name",
    createConversation: "Create conversation",
    search: "Search conversation",
    deleteTitle: "Delete conversation",
    deleteGroup: "Delete this internal group for every participant? The messages are lost and this cannot be undone.",
    deleteDirect: "Delete this direct conversation? It disappears for both sides, with every message, and this cannot be undone.",
    leaveConversation: "Leave conversation",
    leaveTitle: "Leave conversation",
    leaveGroup: "Leave this group? It leaves your list and you stop receiving messages. Nothing is deleted, and an administrator can add you back.",
    leaveDirect: "Leave this conversation? It leaves your list without deleting anything, and comes back if the other person writes again.",
    manageGroup: "Manage group members",
    participants: "Participants",
    groupAutoInclude: "The group always includes you automatically.",
    cancel: "Cancel",
    saveParticipants: "Save members",
    group: "Group",
    direct: "Direct",
    unread: "{{count}} new",
    emptyTitle: "No internal conversation",
    emptyAdmin: "Create a direct conversation or a group for your team.",
    emptyUser: "Create a direct conversation to talk with your team.",
    headerGroupCount: "{{count}} participant{{suffix}}",
    directHeader: "Direct conversation",
    manageParticipants: "Manage members",
    deleteConversation: "Delete conversation",
    userFallback: "User",
    imageAlt: "Sent image",
    openFile: "Open file",
    file: "File",
    noMessagesTitle: "No messages yet",
    noMessagesSubtitle: "Start the conversation with your team here.",
    composerPlaceholder: "Type an internal message",
    selectTitle: "Select an internal conversation",
    selectSubtitle: "Direct and group internal chat stays separate from tickets so the team can collaborate without mixing with the client.",
    today: "Today",
    yesterday: "Yesterday",
    groupNoMessages: "Internal group without messages",
    directNoMessages: "Internal conversation without messages",
    groupFallback: "Internal group",
    directFallback: "Internal conversation",
    noParticipant: "No participant defined",
    media: {
      imageReady: "Image ready to send",
      audioReady: "Audio ready to send",
      pdfReady: "PDF ready to send",
      fileReady: "File ready to send"
    },
    errors: {
      mediaType: "Only JPEG, PNG and PDF are allowed in internal chat."
    }
  },
  es: {
    title: "Chat interno",
    refresh: "Actualizar",
    newConversation: "Nueva conversacion",
    newDirectConversation: "Nueva conversacion individual",
    newInternalConversation: "Nueva conversacion interna",
    type: "Tipo",
    chooseUser: "Elige el usu\u00e1rio",
    groupName: "Nombre del grupo",
    createConversation: "Crear conversacion",
    search: "Buscar conversacion",
    deleteTitle: "Borrar conversacion",
    deleteGroup: "Deseas borrar este grupo interno para todos los participantes? Los mensajes se pierden y no hay forma de deshacerlo.",
    deleteDirect: "Deseas borrar esta conversacion individual? Desaparece para ambos lados, con todos los mensajes, y no hay forma de deshacerlo.",
    leaveConversation: "Salir de la conversacion",
    leaveTitle: "Salir de la conversacion",
    leaveGroup: "Deseas salir de este grupo? Sale de tu lista y dejas de recibir los mensajes. No se borra nada, y un administrador puede volver a agregarte.",
    leaveDirect: "Deseas salir de esta conversacion? Sale de tu lista sin borrar nada, y vuelve si la persona escribe de nuevo.",
    manageGroup: "Gestionar integrantes del grupo",
    participants: "Participantes",
    groupAutoInclude: "El grupo siempre te incluye automaticamente.",
    cancel: "Cancelar",
    saveParticipants: "Guardar integrantes",
    group: "Grupo",
    direct: "Individual",
    unread: "{{count}} nueva{{suffix}}",
    emptyTitle: "Ninguna conversacion interna",
    emptyAdmin: "Crea una conversacion individual o un grupo para tu equipo.",
    emptyUser: "Crea una conversacion individual para hablar con tu equipo.",
    headerGroupCount: "{{count}} participante{{suffix}}",
    directHeader: "Conversacion individual",
    manageParticipants: "Gestionar integrantes",
    deleteConversation: "Borrar conversacion",
    userFallback: "Usu\u00e1rio",
    imageAlt: "Imagen enviada",
    openFile: "Abrir archivo",
    file: "Archivo",
    noMessagesTitle: "Sin mensajes aun",
    noMessagesSubtitle: "Empieza la conversacion con tu equipo por aqui.",
    composerPlaceholder: "Escribe un mensaje interno",
    selectTitle: "Selecciona una conversacion interna",
    selectSubtitle: "El chat interno individual y en grupo queda separado de los tickets para que el equipo colabore sin mezclarlo con el cliente.",
    today: "Hoy",
    yesterday: "Ayer",
    groupNoMessages: "Grupo interno sin mensajes",
    directNoMessages: "Conversacion interna sin mensajes",
    groupFallback: "Grupo interno",
    directFallback: "Conversacion interna",
    noParticipant: "Sin participante definido",
    media: {
      imageReady: "Imagen lista para enviar",
      audioReady: "Audio listo para enviar",
      pdfReady: "PDF listo para enviar",
      fileReady: "Archivo listo para enviar"
    },
    errors: {
      mediaType: "Solo JPEG, PNG y PDF estan permitidos en el chat interno."
    }
  }
};

const adminTexts = {
  pt: {
    common: {
      refresh: "Atualizar",
      cancel: "Cancelar",
      apply: "Aplicar",
      clear: "Limpar",
      save: "Salvar",
      saving: "Salvando...",
      close: "Fechar",
      edit: "Editar",
      delete: "Deletar",
      actions: "Ações",
      status: "Status",
      name: "Nome",
      connection: "Conex\u00e3o",
      queue: "Fila",
      attendant: "Atendente",
      subject: "Assunto",
      protocol: "Protocolo",
      noContact: "Sem contato",
      noConnection: "Sem conex\u00e3o",
      noQueue: "Sem fila",
      noAttendant: "Sem atendente",
      unavailableNumber: "Número não disponível"
    },
    attendances: {
      title: "Atendimentos",
      historyTitle: "Histórico de atendimentos",
      historySubtitle: "Consulte atendimentos encerrados com filtros administrativos e, quando necessario, use a aba de gerenciamento para ações em lote.",
      historyTab: "Histórico",
      managementTab: "Gerenciamento",
      filtersTitle: "Filtros do histórico",
      filtersSubtitle: "Refine os atendimentos encerrados por nome, fila, atendente, conex\u00e3o, tag e per\u00edodo.",
      search: "Buscar",
      searchPlaceholder: "Nome, número, assunto ou conteudo",
      ticketId: "ID do atendimento",
      ticketIdPlaceholder: "Somente numeros, ex: 2996",
      contactDocument: "CPF / CNPJ",
      contactDocumentPlaceholder: "Com ou sem pontuacao",
      contactNumber: "Telefone",
      contactNumberPlaceholder: "Com ou sem DDI e pontuacao",
      contactEmail: "E-mail",
      contactEmailPlaceholder: "Parte do e-mail ja basta",
      customField: "Campo adicional",
      customFieldAny: "Qualquer campo",
      customFieldHelper: "Deixe em Qualquer campo para buscar o valor em todos.",
      customFieldEmpty: "Nenhum campo adicional cadastrado nos contatos.",
      customFieldValue: "Valor do campo adicional",
      customFieldValuePlaceholder: "Parte do valor ja basta",
      from: "De",
      to: "Ate",
      activeFilters: "{{count}} filtro(s) ativo(s)",
      noActiveFilters: "Sem filtros ativos. Exibindo os atendimentos encerrados mais recentes.",
      showFilters: "Exibir filtros",
      export: "Exportar",
      exportDetailed: "Analitico (com linha do tempo)",
      exportSummary: "Sintetico (sem linha do tempo)",
      exporting: "Exportando... {{progress}}%",
      exportDone: "{{count}} atendimento(s) exportado(s).",
      exportEmpty: "Nenhum atendimento para exportar com os filtros atuais.",
      exportTruncated: "Exportados {{exported}} de {{total}} atendimentos (limite por exportacao). Refine os filtros para obter o restante.",
      loadedClosed: "Encerrados carregados",
      totalFound: "Total encontrado",
      withAttendant: "Com atendente",
      inPeriod: "No per\u00edodo",
      averageSla: "SLA medio",
      averageTme: "TME medio",
      averageTma: "TMA medio",
      averageRating: "Avaliação media",
      operation: "Operacao",
      tme: "TME",
      tma: "TMA",
      slaTime: "Tempo SLA",
      totalTime: "Tempo total",
      transfers: "Transferencias",
      queueFlow: "Fluxo de filas",
      operationalTimeline: "Linha do tempo operacional",
      transferCount: "{{count}} transf.",
      rating: "Avaliação",
      noRating: "Sem avalia\u00e7\u00e3o",
      ratingPending: "Aguardando",
      ratingScore: "{{score}} estrelas",
      handledModes: {
        human: "Humano",
        ai: "IA",
        hybrid: "Hibrido",
        unknown: "N\u00e3o definido"
      },
      department: "Departamento",
      tags: "Etiquetas",
      closedAt: "Encerrado em",
      startedAt: "Início",
      protocolNumber: "Número de protocolo",
      emptyHistory: "Nenhum atendimento encerrado encontrado com os filtros atuais.",
      connections: "Conex\u00f5es",
      open: "Atendendo",
      pending: "Aguardando",
      resolved: "Resolvidos",
      globalActions: "Ações globais",
      globalDescription: "Use estas ações com cautela. Elas afetam atendimentos de todas as conex\u00f5es visiveis nesta tela. Atendimentos resolvidos nao sao afetados.",
      closeOpen: "Fechar \"Atendendo\"",
      closePending: "Fechar \"Aguardando\"",
      closeAll: "Fechar \"Atendendo\" e \"Aguardando\"",
      closeAllPlural: "Fechar \"Atendendo\" e \"Aguardando\"",
      deleteOpen: "Deletar \"Atendendo\"",
      deletePending: "Deletar \"Aguardando\"",
      deleteAll: "Deletar \"Atendendo\" e \"Aguardando\"",
      deleteAllPlural: "Deletar \"Atendendo\" e \"Aguardando\"",
      connectionStatus: "Status da conex\u00e3o: {{status}}",
      groupsActive: "Grupos ativos",
      groupsDisabled: "Grupos desativados",
      openCount: "Atendendo: {{count}}",
      pendingCount: "Aguardando: {{count}}",
      resolvedCount: "Resolvidos: {{count}}",
      emptyManagement: "Nenhuma conex\u00e3o encontrada para gerenciamento de atendimentos.",
      allConnections: "em todas as conex\u00f5es",
      connectionScope: "na conex\u00e3o {{name}}",
      confirmCloseTitle: "Confirmar fechamento de atendimentos",
      confirmCloseMessage: "Deseja fechar todos os chamados {{affected}} {{scope}}? Essa operacao não podera ser desfeita.",
      confirmDeleteTitle: "Confirmar exclusão de atendimentos",
      confirmDeleteMessage: "Deseja deletar todos os chamados {{affected}} {{scope}}? Essa operacao e permanente e não podera ser desfeita.",
      deletedSuccess: "Atendimentos deletados com sucesso.",
      updatedSuccess: "Atendimentos atualizados com sucesso.",
      attendantFallback: "Atendente (ID {{id}})"
    },
    settings: {
      general: "Geral",
      integrations: "Integrações",
      awayMinutes: "Tempo para considerar ausente (minutos)",
      awayMinutesHelp: "Depois desse tempo sem atividade, o atendente passa para ausente.",
      dashboardTimezone: "Timezone do dashboard",
      dashboardTimezoneHelp: "Usado para ajustar o horario e o per\u00edodo dos graficos da dashboard.",
      ticketListOrder: "Ordem da lista de atendimentos",
      ticketListOrderHelp: "Vale para Atendendo e Aguardando. Em \"mais antigos primeiro\", o atendimento aberto ha mais tempo fica em cima e nao sai do lugar quando chega mensagem nova.",
      ticketListOrderRecent: "Mais recentes primeiro (padrao)",
      ticketListOrderOldest: "Mais antigos primeiro (ordem de chegada)",
      transcriptionTitle: "Transcrição de audio",
      transcriptionSubtitle: "Transcreve áudios recebidos de clientes e exibe o texto abaixo do player na conversa.",
      saveTranscription: "Salvar transcri\u00e7\u00e3o",
      transcriptionAi: "IA de transcri\u00e7\u00e3o",
      model: "Modelo",
      providerModelPlaceholder: "modelo do provedor",
      modelHelp: "Ex.: whisper-1 para OpenAI. Para Grok, use o modelo habilitado na sua conta.",
      language: "Idioma",
      languageHelp: "Opcional. Use pt para portugues.",
      customEndpoint: "Endpoint personalizado",
      endpointHelp: "Deixe vazio para usar o endpoint padr\u00e3o do provedor.",
      apiKey: "Chave da API",
      apiKeyHelp: "Deixe em branco para manter a chave atual.",
      disabled: "Desativada",
      enabled: "Ativada",
      searchToken: "Buscar por nome",
      generateToken: "Gerar token",
      editToken: "Editar token",
      tokenName: "Nome do token",
      expirationDate: "Data de expiração",
      token: "Token",
      revoke: "Revogar",
      noTokens: "Nenhum token encontrado.",
      copyNow: "Copie este token agora. Depois que esta janela for fechada, ele não sera exibido novamente.",
      tokenNamePlaceholder: "Insira um nome para o token",
      expirationTerm: "Prazo para a expiração",
      expirationPlaceholder: "Selecione um prazo para expiração",
      requiredField: "Este campo e obrigatório.",
      copyToken: "Copiar token",
      tokenValidation: "Informe o nome e o prazo de expiração do token.",
      modelValidation: "Informe o modelo de transcri\u00e7\u00e3o.",
      expirationOptions: {
        "30d": "30 dias",
        "90d": "90 dias",
        "180d": "180 dias",
        "1y": "1 ano",
        never: "Não expirar"
      },
      active: "Ativo",
      revoked: "Revogado",
      expired: "Expirado"
    }
  },
  en: {
    common: {
      refresh: "Refresh",
      cancel: "Cancel",
      apply: "Apply",
      clear: "Clear",
      save: "Save",
      saving: "Saving...",
      close: "Close",
      edit: "Edit",
      delete: "Delete",
      actions: "Actions",
      status: "Status",
      name: "Name",
      connection: "Connection",
      queue: "Queue",
      attendant: "Attendant",
      subject: "Subject",
      protocol: "Protocol",
      noContact: "No contact",
      noConnection: "No connection",
      noQueue: "No queue",
      noAttendant: "No attendant",
      unavailableNumber: "Number unavailable"
    },
    attendances: {
      title: "Attendances",
      historyTitle: "Attendance history",
      historySubtitle: "Review closed attendances with administrative filters and, when needed, use the management tab for batch actions.",
      historyTab: "History",
      managementTab: "Management",
      filtersTitle: "History filters",
      filtersSubtitle: "Refine closed attendances by id, contact, queue, attendant, connection, tag, custom fields and period.",
      search: "Search",
      searchPlaceholder: "Name, number, subject or content",
      ticketId: "Ticket ID",
      ticketIdPlaceholder: "Digits only, e.g. 2996",
      contactDocument: "Tax ID",
      contactDocumentPlaceholder: "With or without punctuation",
      contactNumber: "Phone",
      contactNumberPlaceholder: "With or without country code",
      contactEmail: "Email",
      contactEmailPlaceholder: "Part of the email is enough",
      customField: "Custom field",
      customFieldAny: "Any field",
      customFieldHelper: "Keep Any field to search the value across all of them.",
      customFieldEmpty: "No custom fields registered on contacts.",
      customFieldValue: "Custom field value",
      customFieldValuePlaceholder: "Part of the value is enough",
      from: "From",
      to: "To",
      activeFilters: "{{count}} active filter(s)",
      noActiveFilters: "No active filters. Showing the most recent closed attendances.",
      showFilters: "Show filters",
      export: "Export",
      exportDetailed: "Detailed (with timeline)",
      exportSummary: "Summary (without timeline)",
      exporting: "Exporting... {{progress}}%",
      exportDone: "{{count}} attendance(s) exported.",
      exportEmpty: "No attendances to export with the current filters.",
      exportTruncated: "Exported {{exported}} of {{total}} attendances (per-export limit). Refine the filters to get the rest.",
      loadedClosed: "Loaded closed",
      totalFound: "Total found",
      withAttendant: "With attendant",
      inPeriod: "In period",
      averageSla: "Average SLA",
      averageTme: "Average FRT",
      averageTma: "Average AHT",
      averageRating: "Average rating",
      operation: "Operation",
      tme: "FRT",
      tma: "AHT",
      slaTime: "SLA time",
      totalTime: "Total time",
      transfers: "Transfers",
      queueFlow: "Queue flow",
      operationalTimeline: "Operational timeline",
      transferCount: "{{count}} transf.",
      rating: "Rating",
      noRating: "No rating",
      ratingPending: "Pending",
      ratingScore: "{{score}} stars",
      handledModes: {
        human: "Human",
        ai: "AI",
        hybrid: "Hybrid",
        unknown: "Not defined"
      },
      department: "Department",
      tags: "Tags",
      closedAt: "Closed at",
      startedAt: "Started",
      protocolNumber: "Protocol number",
      emptyHistory: "No closed attendance found with the current filters.",
      connections: "Connections",
      open: "In service",
      pending: "Waiting",
      resolved: "Resolved",
      globalActions: "Global actions",
      globalDescription: "Use these actions carefully. They affect attendances from all connections visible on this screen. Resolved attendances are not affected.",
      closeOpen: "Close \"In service\"",
      closePending: "Close \"Waiting\"",
      closeAll: "Close \"In service\" and \"Waiting\"",
      closeAllPlural: "Close \"In service\" and \"Waiting\"",
      deleteOpen: "Delete \"In service\"",
      deletePending: "Delete \"Waiting\"",
      deleteAll: "Delete \"In service\" and \"Waiting\"",
      deleteAllPlural: "Delete \"In service\" and \"Waiting\"",
      connectionStatus: "Connection status: {{status}}",
      groupsActive: "Groups active",
      groupsDisabled: "Groups disabled",
      openCount: "In service: {{count}}",
      pendingCount: "Waiting: {{count}}",
      resolvedCount: "Resolved: {{count}}",
      emptyManagement: "No connection found for attendance management.",
      allConnections: "across all connections",
      connectionScope: "in connection {{name}}",
      confirmCloseTitle: "Confirm attendance closing",
      confirmCloseMessage: "Do you want to close all {{affected}} tickets {{scope}}? This operation cannot be undone.",
      confirmDeleteTitle: "Confirm attendance deletion",
      confirmDeleteMessage: "Do you want to delete all {{affected}} tickets {{scope}}? This operation is permanent and cannot be undone.",
      deletedSuccess: "Attendances deleted successfully.",
      updatedSuccess: "Attendances updated successfully.",
      attendantFallback: "Attendant (ID {{id}})"
    },
    settings: {
      general: "General",
      integrations: "Integrations",
      awayMinutes: "Time to mark away (minutes)",
      awayMinutesHelp: "After this time without activity, the attendant is marked away.",
      dashboardTimezone: "Dashboard timezone",
      dashboardTimezoneHelp: "Used to adjust dashboard chart time and period.",
      ticketListOrder: "Ticket list order",
      ticketListOrderHelp: "Applies to In service and Waiting. With \"oldest first\", the ticket opened longest ago stays on top and keeps its place when a new message arrives.",
      ticketListOrderRecent: "Most recent first (default)",
      ticketListOrderOldest: "Oldest first (arrival order)",
      transcriptionTitle: "Audio transcription",
      transcriptionSubtitle: "Transcribes customer audio messages and displays the text below the player in the conversation.",
      saveTranscription: "Save transcription",
      transcriptionAi: "Transcription AI",
      model: "Model",
      providerModelPlaceholder: "provider model",
      modelHelp: "Example: whisper-1 for OpenAI. For Grok, use the model enabled in your account.",
      language: "Language",
      languageHelp: "Optional. Use pt for Portuguese.",
      customEndpoint: "Custom endpoint",
      endpointHelp: "Leave blank to use the provider default endpoint.",
      apiKey: "API key",
      apiKeyHelp: "Leave blank to keep the current key.",
      disabled: "Disabled",
      enabled: "Enabled",
      searchToken: "Search by name",
      generateToken: "Generate token",
      editToken: "Edit token",
      tokenName: "Token name",
      expirationDate: "Expiration date",
      token: "Token",
      revoke: "Revoke",
      noTokens: "No token found.",
      copyNow: "Copy this token now. After this window is closed, it will not be shown again.",
      tokenNamePlaceholder: "Enter a token name",
      expirationTerm: "Expiration term",
      expirationPlaceholder: "Select an expiration term",
      requiredField: "This field is required.",
      copyToken: "Copy token",
      tokenValidation: "Enter the token name and expiration term.",
      modelValidation: "Enter the transcription model.",
      expirationOptions: {
        "30d": "30 days",
        "90d": "90 days",
        "180d": "180 days",
        "1y": "1 year",
        never: "Never expire"
      },
      active: "Active",
      revoked: "Revoked",
      expired: "Expired"
    }
  },
  es: {
    common: {
      refresh: "Actualizar",
      cancel: "Cancelar",
      apply: "Aplicar",
      clear: "Limpiar",
      save: "Guardar",
      saving: "Guardando...",
      close: "Cerrar",
      edit: "Editar",
      delete: "Borrar",
      actions: "Acciones",
      status: "Estado",
      name: "Nombre",
      connection: "Conexion",
      queue: "Cola",
      attendant: "Agente",
      subject: "Asunto",
      protocol: "Protocolo",
      noContact: "Sin contacto",
      noConnection: "Sin conexion",
      noQueue: "Sin cola",
      noAttendant: "Sin agente",
      unavailableNumber: "Numero no disponible"
    },
    attendances: {
      title: "Atenciones",
      historyTitle: "Historial de atenciones",
      historySubtitle: "Consulta atenciones cerradas con filtros administrativos y, cuando sea necesario, usa la pestana de gestion para acciones en lote.",
      historyTab: "Historial",
      managementTab: "Gestion",
      filtersTitle: "Filtros del historial",
      filtersSubtitle: "Refina las atenciones cerradas por nombre, cola, agente, conexion, tag y per\u00edodo.",
      search: "Buscar",
      searchPlaceholder: "Nombre, numero, asunto o contenido",
      ticketId: "ID de la atencion",
      ticketIdPlaceholder: "Solo numeros, ej: 2996",
      contactDocument: "CPF / CNPJ",
      contactDocumentPlaceholder: "Con o sin puntuacion",
      contactNumber: "Telefono",
      contactNumberPlaceholder: "Con o sin codigo de pais",
      contactEmail: "Correo",
      contactEmailPlaceholder: "Parte del correo ya basta",
      customField: "Campo adicional",
      customFieldAny: "Cualquier campo",
      customFieldHelper: "Deje Cualquier campo para buscar el valor en todos.",
      customFieldEmpty: "Ningun campo adicional registrado en los contactos.",
      customFieldValue: "Valor del campo adicional",
      customFieldValuePlaceholder: "Parte del valor ya basta",
      from: "Desde",
      to: "Hasta",
      activeFilters: "{{count}} filtro(s) activo(s)",
      noActiveFilters: "Sin filtros activos. Mostrando las atenciones cerradas mas recientes.",
      showFilters: "Mostrar filtros",
      export: "Exportar",
      exportDetailed: "Analitico (con linea de tiempo)",
      exportSummary: "Sintetico (sin linea de tiempo)",
      exporting: "Exportando... {{progress}}%",
      exportDone: "{{count}} atencion(es) exportada(s).",
      exportEmpty: "Ninguna atencion para exportar con los filtros actuales.",
      exportTruncated: "Exportadas {{exported}} de {{total}} atenciones (limite por exportacion). Refina los filtros para obtener el resto.",
      loadedClosed: "Cerradas cargadas",
      totalFound: "Total encontrado",
      withAttendant: "Con agente",
      inPeriod: "En el per\u00edodo",
      averageSla: "SLA promedio",
      averageTme: "TPR medio",
      averageTma: "TMA medio",
      averageRating: "Evaluacion promedio",
      operation: "Operacion",
      tme: "TPR",
      tma: "TMA",
      slaTime: "Tiempo SLA",
      totalTime: "Tiempo total",
      transfers: "Transferencias",
      queueFlow: "Flujo de colas",
      operationalTimeline: "Linea de tiempo operacional",
      transferCount: "{{count}} transf.",
      rating: "Evaluacion",
      noRating: "Sin evaluacion",
      ratingPending: "Pendiente",
      ratingScore: "{{score}} estrellas",
      handledModes: {
        human: "Humano",
        ai: "IA",
        hybrid: "Hibrido",
        unknown: "No definido"
      },
      department: "Departamento",
      tags: "Etiquetas",
      closedAt: "Cerrado en",
      startedAt: "Inicio",
      protocolNumber: "Numero de protocolo",
      emptyHistory: "No se encontro ninguna atencion cerrada con los filtros actuales.",
      connections: "Conexiones",
      open: "En atencion",
      pending: "Esperando",
      resolved: "Resueltas",
      globalActions: "Acciones globales",
      globalDescription: "Usa estas acciones con cautela. Afectan atenciones de todas las conexiones visibles en esta pantalla. Las atenciones resueltas no se ven afectadas.",
      closeOpen: "Cerrar \"En atencion\"",
      closePending: "Cerrar \"Esperando\"",
      closeAll: "Cerrar \"En atencion\" y \"Esperando\"",
      closeAllPlural: "Cerrar \"En atencion\" y \"Esperando\"",
      deleteOpen: "Borrar \"En atencion\"",
      deletePending: "Borrar \"Esperando\"",
      deleteAll: "Borrar \"En atencion\" y \"Esperando\"",
      deleteAllPlural: "Borrar \"En atencion\" y \"Esperando\"",
      connectionStatus: "Estado de la conexion: {{status}}",
      groupsActive: "Grupos activos",
      groupsDisabled: "Grupos desactivados",
      openCount: "En atencion: {{count}}",
      pendingCount: "Esperando: {{count}}",
      resolvedCount: "Resueltas: {{count}}",
      emptyManagement: "No se encontro ninguna conexion para gestion de atenciones.",
      allConnections: "en todas las conexiones",
      connectionScope: "en la conexion {{name}}",
      confirmCloseTitle: "Confirmar cierre de atenciones",
      confirmCloseMessage: "Deseas cerrar todos los tickets {{affected}} {{scope}}? Esta operacion no se podra deshacer.",
      confirmDeleteTitle: "Confirmar borrado de atenciones",
      confirmDeleteMessage: "Deseas borrar todos los tickets {{affected}} {{scope}}? Esta operacion es permanente y no se podra deshacer.",
      deletedSuccess: "Atenciones borradas con exito.",
      updatedSuccess: "Atenciones actualizadas con exito.",
      attendantFallback: "Agente (ID {{id}})"
    },
    settings: {
      general: "General",
      integrations: "Integraciones",
      awayMinutes: "Tiempo para considerar ausente (minutos)",
      awayMinutesHelp: "Despues de este tiempo sin actividad, el agente pasa a ausente.",
      dashboardTimezone: "Zona horaria del dashboard",
      dashboardTimezoneHelp: "Usado para ajustar la hora y el per\u00edodo de los graficos del dashboard.",
      ticketListOrder: "Orden de la lista de atenciones",
      ticketListOrderHelp: "Vale para Atendiendo y En espera. Con \"mas antiguos primero\", la atencion abierta hace mas tiempo queda arriba y no pierde su lugar cuando llega un mensaje nuevo.",
      ticketListOrderRecent: "Mas recientes primero (predeterminado)",
      ticketListOrderOldest: "Mas antiguos primero (orden de llegada)",
      transcriptionTitle: "Transcripcion de audio",
      transcriptionSubtitle: "Transcribe audios recibidos de clientes y muestra el texto debajo del reproductor en la conversacion.",
      saveTranscription: "Guardar transcripcion",
      transcriptionAi: "IA de transcripcion",
      model: "Modelo",
      providerModelPlaceholder: "modelo del proveedor",
      modelHelp: "Ej.: whisper-1 para OpenAI. Para Grok, usa el modelo habilitado en tu cuenta.",
      language: "Idioma",
      languageHelp: "Opcional. Usa pt para portugues.",
      customEndpoint: "Endpoint personalizado",
      endpointHelp: "Dejalo vacio para usar el endpoint predeterminado del proveedor.",
      apiKey: "Clave API",
      apiKeyHelp: "Dejalo en blanco para mantener la clave actual.",
      disabled: "Desactivada",
      enabled: "Activada",
      searchToken: "Buscar por nombre",
      generateToken: "Generar token",
      editToken: "Editar token",
      tokenName: "Nombre del token",
      expirationDate: "Fecha de expiracion",
      token: "Token",
      revoke: "Revocar",
      noTokens: "Ningun token encontrado.",
      copyNow: "Copia este token ahora. Despues de cerrar esta ventana, no se mostrara nuevamente.",
      tokenNamePlaceholder: "Ingresa un nombre para el token",
      expirationTerm: "Plazo de expiracion",
      expirationPlaceholder: "Selecciona un plazo de expiracion",
      requiredField: "Este campo es obligatorio.",
      copyToken: "Copiar token",
      tokenValidation: "Informa el nombre y el plazo de expiracion del token.",
      modelValidation: "Informa el modelo de transcripcion.",
      expirationOptions: {
        "30d": "30 dias",
        "90d": "90 dias",
        "180d": "180 dias",
        "1y": "1 ano",
        never: "No expirar"
      },
      active: "Activo",
      revoked: "Revocado",
      expired: "Expirado"
    }
  }
};

const getTexts = texts => texts[languageCode()] || texts.pt;

export const getDashboardTexts = () => getTexts(dashboardTexts);
export const getInternalChatTexts = () => getTexts(internalChatTexts);
export const getAdminTexts = () => getTexts(adminTexts);
